/** How often a navigation badge count refreshes while the tab is visible. */
export const NAV_BADGE_POLL_MS = 60 * 1000;

/**
 * The options of a badge poll (#2193 B): every `intervalMs` while the tab is
 * visible, and at once when it becomes visible again. TanStack Query skips
 * interval fetches while `document.visibilityState` is 'hidden' unless
 * `refetchIntervalInBackground` is set; stating it here keeps a hidden tab
 * from polling even if the client default changes.
 */
export function visiblePoll(intervalMs: number) {
  return {
    refetchInterval: intervalMs,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  } as const;
}
